<template>
    <div full-height>
        <v-toolbar flat fixed>
            <v-toolbar-title>{{ $t('setBackupDrive.toolbarTitle') }}</v-toolbar-title>
        </v-toolbar>

        <div class="hastoolbar hasfooter">
            <v-alert type="info" :value="msgAlert">
                {{ $t('setBackupDrive.alertMessage') }}
            </v-alert>

            <v-card noshadow>
                <v-card-text>

                    <div center-align>
                        <p class="title grey-color" style="line-height:28px !important">
                            {{ $t('setBackupDrive.setupPrefix') }}<span dark-opacity-color><strong>{{$root.CurrentBusiness.BusinessName}}</strong></span>
                        </p><br>

                        <div>
                            <v-btn color="primary" @click="fn_showGoogleAccounts">
                                {{ $t('setBackupDrive.setUpDriveBtn') }}
                            </v-btn>
                        </div>
                    </div>

                </v-card-text>
            </v-card>

            <div class="page-footer">
                <div class="watermark">
                    <div class="title">BizOps</div>
                </div>
            </div>
        </div>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod"></dialog-confirmation>

    </div>
</template>

<script>

const dialogjs =  require('../../dialog').dialogjs;
import dialogConfirmation from '../dialogs/dialog_confirmation'

    export default{
        data(){
            return{
                loading:false,
                msgAlert:false,
                confirmationMessage:null,
                confirmationHeader:null,
                actionMethod:null,
                dialogStorageId:null,
            }
        },
        components:{
            'dialog-confirmation': dialogConfirmation
        },
        methods:{

            fn_showGoogleAccounts: function(){
                var self = this;
                /*global AndroidRoutingTest*/
                AndroidRoutingTest.revokeAccount();
                this.getData('ShowGoogleAccounts', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            //Pushing default data
                            self.$root.fn_pushDefaultJson(function(){
                                self.$root.fn_getAuthToken(function(token){
                                    token != 'error' ?  self.fn_setBackupDrive(response, token) : '';
                                })
                            });
                        }, 
                        onError: function(error){
                            self.msgAlert = true;
                            console.log(error);
                        }
                    }
                );
            },

            fn_setBackupDrive: function(backupAccountId, token){
                if(!navigator.onLine){
                    this.showToast(this.$t('common.internetNotAvailable'));
                    return;
                }

                let self = this;
                let postObj = {};
                postObj.BusinessID = this.$root.CurrentBusiness.BusinessID,
                postObj.DataDriveLocation = backupAccountId;
                postObj.token = token;

                if(!token){
                    console.log("Token not found!");
                    this.showToast(this.$t('common.somethingWentWrong'));
                    return;
                }

                this.showLoading(this.$t('common.pleaseWait'));

                this.postServerData('SetDataDrive', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_resetDatabase();
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            AndroidRoutingTest.revokeAccount();
                            if(typeof JSON.parse(error) == 'object'){
                                let response = JSON.parse(error);
                                self.showToast(response.Message);
                            }
                        }
                    }
                );
            },

            fn_resetDatabase: function(){
                let self = this;
                this.getData('ResetDatabase', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            let status = JSON.parse(response);
                            if(status!=null){
                                self.showToast(self.$t('setBackupDrive.driveSetupComplete'));
                                self.$root.fn_loadMainApp();
                            }
                            else{
                                self.showToast(self.$t('common.somethingWentWrong'));
                            }
                            self.hideLoading();
                        }, 
                        onError: function(error){
                            console.log(error, 'error in reset database');
                            self.showToast(self.$t('common.somethingWentWrong'));
                        }
                    }
                );
            },

            // removing database before going back
            fn_removeBusinessData: function(){
                let self = this;
                this.getData('RemoveBusinessData', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_quitConfirmation();
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_openDialogWeb: function (platform, name, ref) {

                let scroll_y = window.scrollY;
                this.fn_fixBackgroundScroll();

                var dialogObj = {};
                dialogObj.tagId = this.guidWeb();
                dialogObj.formId = this.formId;
                dialogObj.name = name;
                dialogObj.ref = ref;
                dialogObj.data = null;
                dialogObj.platform = platform;

                dialogObj.scrollPosition = {};
                dialogObj.scrollPosition.x = 0;
                dialogObj.scrollPosition.y = scroll_y;

                dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

                this.$refs[ref].openDialogWeb();
            },

            fn_openDialogConfirmation: function(){
                this.fn_openDialogWeb('web', 'Confirmation', 'ref_dialogConfirmation')
            },

            fn_closeDialog: function () {
                dialogjs.fn_checkAndCloseOpenDialogs(this);
            },

            fn_quit: function(){
                var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
                if(dialogData && dialogData.length){
                    dialogjs.fn_checkAndCloseOpenDialogs(this);
                }
                else{
                    this.confirmationMessage = null;
                    this.confirmationHeader = this.$t('setBackupDrive.quitDriveSetupHeader');
                    this.actionMethod = this.fn_removeBusinessData;
                    this.fn_openDialogConfirmation();
                }
            },

            fn_quitConfirmation: function(){
                this.fn_closeDialog();
                let self = this;
                setTimeout(function(){
                    // will run if restore screen coming from login view
                    if(window.history.length==2){
                        self.$router.go(-1);
                    }
                    // will run if restore screen coming directly
                    else{
                        self.$router.replace("/registration/business/login");
                    }
                },300);
            },

            fn_goBack: function(){
                this.fn_quit();
            }

        },
        mounted: function(){
            this.dialogStorageId = this.guidWeb();
            window.js_globals.fn_onBackPress = this.fn_goBack;
        },
        beforeRouteLeave (to, from, next) {
            var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
            if(dialogData && dialogData.length){
                dialogjs.fn_checkAndCloseOpenDialogs(this);
                next(false);
            }
            else{
                next();
            }
        }
    }
</script>